import { render, staticRenderFns } from "./autocomplete.vue?vue&type=template&id=bde87184&scoped=true&"
import script from "./autocomplete.vue?vue&type=script&lang=js&"
export * from "./autocomplete.vue?vue&type=script&lang=js&"
import style0 from "./autocomplete.vue?vue&type=style&index=0&id=bde87184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde87184",
  null
  
)

export default component.exports